import { baseTheme } from 'tailwind-config';

const { colors, spacing, boxShadows, fontSizes, breakpoints } = baseTheme;

export { colors, spacing, boxShadows, fontSizes, breakpoints };
